import { useQuery } from '@tanstack/react-query';

import {
  getDashboardAnnouncementById,
  getDashboardAnnouncements,
  getOnLeaveToday,
  getUpcomingHolidays,
} from '@/api/dashboard';

import type { OnLeaveFilter, HolidayFilter } from '@/types/dashboard';

import { normalizeAnnouncement } from '@gokrew/ui/utility/Announcements';
import { QueryKeys } from '@gokrew/models/constants';

export const useOnLeaveToday = (
  filters: OnLeaveFilter,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: [QueryKeys.DashboardOnLeave, filters],
    queryFn: () => getOnLeaveToday(filters),
    enabled: options?.enabled ?? true,
  });
};

export const useUpcomingHolidays = (filters: HolidayFilter) => {
  return useQuery({
    queryKey: [QueryKeys.DashboardHolidays, filters],
    queryFn: () => getUpcomingHolidays(filters),
  });
};

export const useDashboardAnnouncements = (params: {
  page: number;
  limit: number;
}) => {
  return useQuery({
    queryKey: [QueryKeys.DashboardAnnouncements, params],
    queryFn: () => getDashboardAnnouncements(params),
    select: (res) => (res?.data?.data ?? []).map(normalizeAnnouncement),
  });
};

export const useDashboardAnnouncementById = (announcementId: string) => {
  return useQuery({
    queryKey: [QueryKeys.DashboardAnnouncement, announcementId],
    queryFn: () => getDashboardAnnouncementById(announcementId),
    enabled: !!announcementId,
    select: (res) => (res?.data ? normalizeAnnouncement(res.data) : undefined),
  });
};
